import { render } from "./Moved.vue?vue&type=template&id=f1b84fb4"
import script from "./Moved.vue?vue&type=script&lang=js"
export * from "./Moved.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rogerkirton/Documents/Development/Soca Islands Repos/app-soca-islands/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__